module.exports = __webpack_public_path__ + "img/facebook.46be5364.svg";